export default {
  title: 'Check Shipping Cost',
  origin: 'Origin of Delivery',
  originPlaceholder: 'Please input origin of delivery',
  destination: 'Destination of Delivery',
  destinationPlaceholder: 'Please input destination of delivery',
  weight: 'Weight',
  weightPlaceholder: 'Please input weight',
  logistic: 'Logistic',
  allLogistic: 'All Logistic',
  submit: 'Check Cost',
  invalidTitle: 'Cost information is not available',
  invalidDesc: 'Please fill the shipping cost check form to display the shipping cost',
  dataNotFound: 'Sorry, Data not found!',
  show: 'Show',
  service: 'delivery service',
  typeService: "Type of service"
}